import { DEFAULT_LANGUAGE, PlatformLanguages } from 'shared/utils/i18next-config';

export const getLanguageFromCode = (languageCode: string) => {
    return PlatformLanguages.find(language => language.code === languageCode) ?? DEFAULT_LANGUAGE;
};